import React, { useEffect } from 'react';
import './About.css';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out'
    });
  }, []);

  return (
    <div className="about">
      <div className="about-hero">
        <div className="about-overlay"></div>
        <div className="hero-content" data-aos="fade-up">
          <h1 className="gradient-text">ABOUT US</h1>
          <p>Excellence in Metal Fabrication Since 1995</p>
        </div>
      </div>
      
      <section className="about-main">
        <div className="about-container">
          <div className="mission-section" data-aos="fade-up">
            <h2>Our Mission</h2>
            <p className="mission-statement">
              To deliver exceptional metal fabrication solutions through innovation, precision, and unwavering commitment to quality, while building lasting partnerships with our clients.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-text" data-aos="fade-right">
              <h2>Our Story</h2>
              <p>Established in 1995 by Michael Zivanovic, Advanced Metal Shop Ltd. began as a modest family-run workshop in Brampton, Ontario. With a dedicated team of three and fundamental equipment, the company embarked on a journey to provide quality metal fabrication services.</p>
              <p>Over the years, Advanced Metal Shop has evolved into a well-equipped facility, serving clients across various sectors. Our growth is attributed to our commitment to combining traditional craftsmanship with modern technology, ensuring precision and reliability in every project.</p>
              <p>Today, we continue to uphold our founding principles, delivering tailored metal fabrication solutions that meet the unique needs of our clients. Our team remains focused on maintaining high standards of workmanship and fostering long-term relationships within the industry.</p>
              
            </div>
            <div className="about-stats">
              <div className="stat-item" data-aos="fade-up" data-aos-delay="100">
                <h3>25+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat-item" data-aos="fade-up" data-aos-delay="200">
                <h3>200+</h3>
                <p>Projects Completed</p>
              </div>
              <div className="stat-item" data-aos="fade-up" data-aos-delay="300">
                <h3>20+</h3>
                <p>Expert Team Members</p>
              </div>
            </div>
          </div>
          
          <div className="team-section" data-aos="fade-up">
            <h2>Our Leadership Team</h2>
            <div className="team-grid">
              <div className="team-member" data-aos="fade-up" data-aos-delay="100">
                <div className="member-image" style={{ backgroundImage: 'url(/mike.png)', backgroundSize: '88%', backgroundPosition: 'center' }}></div>
                <h3>Michael Zivanovic</h3>
                <p className="member-role">Founder & CEO</p>
                <p className="member-bio">With over 30 years in metal fabrication, Mike leads our company with vision and expertise.</p>
              </div>
              <div className="team-member" data-aos="fade-up" data-aos-delay="200">
                <div className="member-image" style={{ backgroundImage: 'url(/angelo.jpeg)', backgroundSize: '108%', backgroundPosition: 'center' }}></div>
                <h3>Angelo D'Ascenio</h3>
                <p className="member-role">Lead Foreman</p>
                <p className="member-bio">Angelo brings 40 years of work excellence to our technical operations.</p>
              </div>
              <div className="team-member" data-aos="fade-up" data-aos-delay="300">
                <div className="member-image" style={{ backgroundImage: 'url(/jag.jpeg)', backgroundSize: '108%', backgroundPosition: 'center' }}></div>
                <h3>Jag<br />Singh</h3>
                <p className="member-role">Project Manager</p>
                <p className="member-bio">Jag coordinates projects and keeps every job on schedule to our quality standards.</p>
              </div>
              <div className="team-member" data-aos="fade-up" data-aos-delay="400">
                <div className="member-image" style={{ backgroundImage: 'url(/deven.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center top' }}></div>
                <h3>Deven Zivanovic</h3>
                <p className="member-role">Operations Manager</p>
                <p className="member-bio">Deven manages company operations and keeps projects, clients, and teams aligned from start to finish.</p>
              </div>
            </div>
          </div>

          <div className="values-section" data-aos="fade-up">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-card" data-aos="fade-up" data-aos-delay="100">
                <h3>Precision</h3>
                <p>We maintain the highest standards of accuracy in every project we undertake.</p>
              </div>
              <div className="value-card" data-aos="fade-up" data-aos-delay="200">
                <h3>Innovation</h3>
                <p>We continuously invest in new technologies and techniques to stay ahead.</p>
              </div>
              <div className="value-card" data-aos="fade-up" data-aos-delay="300">
                <h3>Quality</h3>
                <p>We never compromise on the quality of our work or materials.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="cta-section" data-aos="fade-up">
        <h2>Join Our Journey</h2>
        <p>Experience the difference of working with a team that's passionate about metal fabrication excellence.</p>
        <Link to="/contact" className="cta-button">Contact Us Today</Link>
      </div>
    </div>
  );
};

export default About; 